import React from "react"
import PropTypes from 'prop-types'

import {FieldAutomationTriggerFormProps} from "../../../../render/automation-trigger-form"
import {SelectParent_RenderType} from "../../../../../gd-ui/select-parent-new/@const"
import SelectParentsNew from "../../../../../gd-ui/select-parent-new/select-parents-new"
import FieldProjects from "../projects"

// const debug = "FieldProjects_AutomationTriggerForm"
const debug = false

export default class FieldProjects_AutomationTriggerForm extends React.Component<FieldAutomationTriggerFormProps,any> {


    static propTypes = {
        config          : PropTypes.object,

        onChangeCallback: PropTypes.func,
    }

    onChangeFromValues    = (projectIds: [])  => {
        this.props.onChangeCallback({fromValues  : projectIds})
    }
    onChangeToValues      = (projectIds: [])  => {
        this.props.onChangeCallback({toValues    : projectIds})
    }

    render() {
        return (
            <div className="flex-row-left-top">
                <div className="label">from</div>
                <SelectParentsNew className     = "selector always-selected"
                                  renderType    = {SelectParent_RenderType.INLINE_EDITABLE}
                                  placeholder   = "Any"
                                  unselectLabel = "Any"
                                  parentsFor    = {(this.props.field as FieldProjects).parentsFor}
                                  projectIds    = {this.props.config.fromValues}
                                  onChange      = {this.onChangeFromValues}/>

                {/*<SelectParent className         = "selector always-selected"
                              renderValue       = "inline-editable"
                              parentsFor        = "common-use"
                              viewMode          = "all"
                              multiselect       = {true}
                              placeholder       = "Any"
                              unselectLabel     = "Any"
                              companies         = {[gd.companyId]}
                              values            = {this.props.config.fromValues ? {projects: this.props.config.fromValues} : null}
                              showProjectIcon   = {true}
                              showIcon          = {true}
                              searchable        = {true}
                              onChange          = {this.onChangeFromValues}/>*/}

                <div className="label">to</div>
                <SelectParentsNew className     = "selector always-selected"
                                  renderType    = {SelectParent_RenderType.INLINE_EDITABLE}
                                  placeholder   = "Any"
                                  unselectLabel = "Any"
                                  parentsFor    = {(this.props.field as FieldProjects).parentsFor}
                                  projectIds    = {this.props.config.toValues}
                                  onChange      = {this.onChangeToValues}/>

                {/*<SelectParent className         = "selector always-selected"
                              renderValue       = "inline-editable"
                              parentsFor        = "common-use"
                              viewMode          = "all"
                              multiselect       = {true}
                              placeholder       = "Any"
                              unselectLabel     = "Any"
                              companies         = {[gd.companyId]}
                              values            = {this.props.config.toValues ? {projects: this.props.config.toValues} : null}
                              showProjectIcon   = {true}
                              showIcon          = {true}
                              searchable        = {true}
                              onChange          = {this.onChangeToValues}/>*/}
            </div>
        )
    }

}